import { render } from "./SurveyQuestion4.vue?vue&type=template&id=7a6c2a1f"
import script from "./SurveyQuestion4.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion4.vue?vue&type=script&lang=js"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__